import React, { useRef } from 'react';

import lottie, { AnimationItem } from 'lottie-web';

import { useIsomorphicLayoutEffect } from '@lib/hooks';
import type { IAirdropBox } from '@type/airdrop';

interface LottieProps {
  /** 是否循环播放 */
  loop?: boolean;
  /** 动画播放完成的回调 */
  onFinish?: () => void;
  /** 空投箱名称 */
  name: IAirdropBox;
  className?: string;
  style?: Record<string, string>;
}

const pathMap: { [key in IAirdropBox]: string } = {
  CAR: '/animations/airdrop/car.json',
  FLOWER: '/animations/airdrop/flower.json',
  TOILET: '/animations/airdrop/toilet.json',
  ROCKET: '/animations/airdrop/rocket.json'
};

export const Lottie: React.FC<LottieProps> = (props) => {
  const { loop = false, name, className, onFinish, style } = props;
  const lottieEl = useRef(null);
  const lottieInstance = useRef<AnimationItem>(null);
  useIsomorphicLayoutEffect(() => {
    lottieInstance.current = lottie.loadAnimation({
      container: lottieEl.current,
      renderer: 'svg',
      loop,
      autoplay: true,
      // path: 'https://assets2.lottiefiles.com/packages/lf20_ctwkstoj.json'
      path: pathMap[name]
    });
    !!onFinish && lottieInstance.current.addEventListener('complete', onFinish);
    return () => {
      !!onFinish &&
        lottieInstance.current.removeEventListener('complete', onFinish);
    };
  }, []);

  return <div ref={lottieEl} className={className} style={style}></div>;
};
